<script>
import userRenderer from '@/views/components/renderers/user-renderer'

export default {
  components: {
    userRenderer
  },
  computed: {
    value() {
      return this.params.getValue();
    }
  }
};
</script>

<template>
  <user-renderer :value="value">
   
  </user-renderer>
</template>
